import { BasicProgram, CircuitProgram, Part, BaseProgram } from "../types";

interface Program extends BaseProgram {
  program: BasicProgram | CircuitProgram;
}

export const getMinute = (time: string) => {
  if (time === null || time === undefined || typeof time !== "string") {
    return 0;
  }
  const [hour, minute] = time.split(":");
  if (hour === undefined || minute === undefined) {
    return 0;
  }

  return parseInt(hour) * 60 + parseInt(minute);
};

export function getWarmUpMinutes(obj: BasicProgram | CircuitProgram) {
  return obj.warmUpMovements.reduce(
    (acc: number, cur: any) => acc + getMinute(cur.time),
    0
  );
}

export function getExerciseMinutes(obj: BasicProgram) {
  return obj.mainExers.reduce(
    (acc: number, cur: any) =>
      acc + getMinute(cur.time) + getMinute(cur.restTime),
    0
  );
}

export function getCoolDownMinutes(obj: BasicProgram | CircuitProgram) {
  return obj.coolDownMovements.reduce(
    (acc: number, cur: any) => acc + getMinute(cur.time),
    0
  );
}

export function getPartMinutes(part: Part) {
  return (
    (getMinute(part.time) + getMinute(part.restTime)) *
      (part.movements ?? []).length *
      part.repeatCount +
    getMinute(part.lastSetRestTime) * (part.movements ?? []).length
  );
}

export function getProgramMinutes({
  program,
  programType,
}: {
  program: BasicProgram | CircuitProgram;
  programType: "BASIC" | "CIRCUIT1" | "CIRCUIT2";
}) {
  const warmUpMinutes = getWarmUpMinutes(program);
  const coolDownMinutes = getCoolDownMinutes(program);
  console.log("program", program);

  if (programType === "BASIC") {
    const exerciseMinutes = getExerciseMinutes(program as BasicProgram);

    return warmUpMinutes + exerciseMinutes + coolDownMinutes;
  }
  if (programType === "CIRCUIT1" || programType === "CIRCUIT2") {
    const part1Minutes = getPartMinutes((program as CircuitProgram).part1);
    const part2Minutes = getPartMinutes((program as CircuitProgram).part2);
    return warmUpMinutes + part1Minutes + part2Minutes + coolDownMinutes;
  }

  return 0;
}

export function getTimeToKo(minute: number) {
  const hour = Math.floor(minute / 60);
  const min = minute % 60;
  return `${hour ? `${hour}분 ` : ""}${min ? `${min}초` : ""}`;
}
